import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { getDeadlineInfo, urgencyColors } from '@/lib/deadline';

interface DeadlineBadgeProps {
    deadline: string;
    className?: string;
}

export function DeadlineBadge({ deadline, className }: DeadlineBadgeProps) {
    const { t } = useTranslation('races');
    const info = getDeadlineInfo(deadline);

    if (info.passed) {
        return <span className={cn("text-slate-400", className)}>{t('dashboard.deadline.passed')}</span>;
    }

    const label = info.days > 0
        ? t('dashboard.deadline.days', { count: info.days })
        : t('dashboard.deadline.hours', { count: info.hours });

    return (
        <span className={cn("flex items-center gap-1 font-semibold", urgencyColors[info.urgency], className)}>
            <Clock size={12} />
            {label}
        </span>
    );
}
